const TOKEN_KEY = "melly_token";
// This app is self-contained: it talks to its OWN backend + database via
// REACT_APP_BACKEND_URL (same-origin on deploy).
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}
export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}

export async function apiLogin(email, password) {
  const body = new URLSearchParams({ username: email, password });
  const r = await fetch(`${BASE}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: body.toString(),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new ApiError(r.status, data.detail ?? "Login failed");
  setToken(data.access_token);
  return data;
}

export async function api(path, init = {}) {
  const token = getToken();
  const headers = new Headers(init.headers);
  headers.set("Content-Type", "application/json");
  if (token) headers.set("Authorization", `Bearer ${token}`);
  const r = await fetch(`${BASE}${path}`, { ...init, headers });
  if (r.status === 204) return undefined;
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new ApiError(r.status, data.detail ?? "Request failed");
  return data;
}

export const apiMe = () => api("/auth/me");
export const apiGetState = () => api("/state");
export const apiPutState = (data) => api("/state", { method: "PUT", body: JSON.stringify({ data }) });

// admin
export const apiListUsers = () => api("/admin/users");
export const apiCreateUser = (body) => api("/admin/users", { method: "POST", body: JSON.stringify(body) });
export const apiDeleteUser = (id) => api(`/admin/users/${id}`, { method: "DELETE" });
export const apiAdminResults = () => api("/admin/results");
